// extracted by mini-css-extract-plugin
export default {"modal":"Invite_modal__46xlg","emailtag":"Invite_emailtag__ItOa1"};